import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone,OnChanges, SimpleChanges, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { RelativeTypeService } from '../../services/relativeType.service';
import { Utilities } from '../../common/utilities';
import { BOItem } from '../../models/BOItem.model';

@Component({
  selector: 'app-patient-allergies',
  templateUrl: './patient-allergies.component.html',
  styleUrls: ['./patient-allergies.component.css']
})
export class PatientAllergiesComponent implements OnInit, OnChanges{
    @Input() id!: number;
    @Input() allergyType!: string;
    @Input() allergen!: string;
    @Input() posInArray!:number;
    @Input() uniqueId!: string;
    @Input() medicAllergyTypeList: BOItem[] = [];
    @Output() posSended = new EventEmitter<{ uniqueId: string }>();
    @Output() posSendedId = new EventEmitter<{ itemId: number }>();

  constructor(private _formBuilder : FormBuilder) { }

    allergiesGroup = this._formBuilder.group({
    posInArray:{ value: null, disabled: true },
    allergyType:{ value: null, disabled: true },
    allergen:{ value: null, disabled: true },
  });

  ngOnInit(): void
  {
    this.patchForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Evitamos el primer cambio porque ngOnInit ya lo maneja
    if (changes['posInArray'] && !changes['posInArray'].firstChange) {
      this.allergiesGroup.patchValue({
        posInArray: this.posInArray + 1
      });
    }
  }



  private patchForm(): void {
    this.allergiesGroup.patchValue({
      posInArray: this.posInArray + 1,
      allergyType: Utilities.getAllergyTypeName(this.allergyType, this.medicAllergyTypeList),
      allergen: this.allergen
    });
  }
deleteItem(): void {
  console.log("Eliminando elemento con ID:", this.uniqueId);

  // this._ngZone.run(() => {
  this.posSended.emit({ uniqueId: this.uniqueId }); // ← Emite ID, no posición

  // })

}

deleteItemSingle(): void {
  console.log("Eliminando elemento con ID:", this.uniqueId);

  // this._ngZone.run(() => {
  this.posSendedId.emit({ itemId: this.id }); // ← Emite ID, no posición

  // })

}
}
